import React from 'react';
import { Checkbox, Flex, Label, Select, ThemeUIStyleObject } from 'theme-ui';

import {
  IsCombineDefinition,
  IsWithDefinition,
  Lang,
  LangEnum,
  OnChangeComponentParams,
} from '../types';

type Props = {
  lang: Lang;
  isWithDefinition: IsWithDefinition;
  isCombineDefinition: IsCombineDefinition;
  onChange: (changed: OnLanguageChangeParams) => void;
};
export type OnLanguageChangeParams = OnChangeComponentParams<Props>;

const styles: Record<string, ThemeUIStyleObject> = {
  label: {
    alignItems: 'center',
    marginRight: 2,
    width: 'auto',
  },
  select: {
    marginLeft: 2,
    cursor: 'pointer',
  },
};

export const LanguageComponent: React.FC<Props> = ({
  lang,
  isWithDefinition,
  isCombineDefinition,
  onChange,
}) => {
  return (
    <Flex px={3}>
      <Label htmlFor="lang" sx={styles.label} pr="10px">
        lang
        <Select
          id="lang"
          name="lang"
          value={lang}
          sx={styles.select}
          onChange={event =>
            onChange({ lang: event.currentTarget.value as Lang })
          }>
          <option value={LangEnum.RU}>{LangEnum.RU}</option>
          <option value={LangEnum.EN}>{LangEnum.EN}</option>
        </Select>
      </Label>

      <Label htmlFor="is-with-definition" sx={styles.label}>
        <Checkbox
          id="is-with-definition"
          checked={isWithDefinition}
          onChange={event =>
            onChange({ isWithDefinition: event.currentTarget.checked })
          }
        />
        definition
      </Label>

      {lang === LangEnum.EN ? (
        <Label htmlFor="is-combine-definition" sx={styles.label}>
          <Checkbox
            id="is-combine-definition"
            checked={isCombineDefinition}
            onChange={event =>
              onChange({ isCombineDefinition: event.currentTarget.checked })
            }
          />
          combine
        </Label>
      ) : null}
    </Flex>
  );
};
